module.exports = __webpack_public_path__ + "img/experience06.ec234161.jpg";